import styled from '@emotion/styled';
import { memo } from 'react';
import { useTranslate } from '@tolgee/react';

interface RecomendTagProps {
  text?: React.ReactNode;
}

export default memo((props: RecomendTagProps) => {
  const { text } = props;
  const { t } = useTranslate();
  return <RecomendTag>{text ? text : t('market.推荐')}</RecomendTag>;
});

const RecomendTag = styled.span`
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0;
  height: 20px;
  line-height: 20px;
  padding: 0 8px;
  font-size: 12px;
  color: #3f434e;
  background: linear-gradient(90deg, #f0dab9 0%, #ffd180 100%);
  border-radius: 6px 0 6px 0;
`;
